<app-admin-navbar [drawer]="drawer"></app-admin-navbar>
<app-sidebar [drawer]="drawer" (event)="toggleNav()"></app-sidebar>

<div class="sm:ml-64">
  <div class="relative overflow-x-hidden rounded-lg dark:border-gray-700 mt-14">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Global Ask Feedback Button -->
<app-ask-feedback-button></app-ask-feedback-button>